/**
 * Constants
 */
const TEST_ACTION = 'TEST_ACTION';

/**
 * Actions creator
 */
const testAction = (data) => {
    console.log(data);
    return {
        type: TEST_ACTION,
        payload: data,
    };
}

/**
 * Exports
 */
const TestActions = {
    testAction,
};

export default TestActions;
export {
    TEST_ACTION,
    testAction,
};



// WEBPACK FOOTER //
// ./actions/TestActions.js